<template>
  <span>
    <widget-common-props :field="field" @changeProp="changeProp" />

    <b-form-group label-cols="3" label="Placeholder">
      <b-form-input
        @change="changeProp"
        label="Placeholder"
        v-model="field.params.placeholder"
      />
    </b-form-group>
    <b-form-group label-cols="3" label="Tooltip">
      <b-form-input
        @change="changeProp"
        label="Tooltip"
        v-model="field.params.tooltip"
      />
    </b-form-group>

    <b-form-group label-cols="3" label="Step">
      <b-form-input
        @change="changeProp"
        min="0"
        type="number"
        v-model="field.params.step"
      />
    </b-form-group>

    <b-form-group label-cols="3" label="Minimum">
      <b-form-input
        @change="changeProp"
        min="0"
        type="number"
        v-model="field.params.min"
      />
    </b-form-group>

    <b-form-group label-cols="3" label="Maximum">
      <b-form-input
        @change="changeProp"
        min="0"
        type="number"
        v-model="field.params.max"
      />
    </b-form-group>

    <!-- Default Settings -->
    <b-form-group label-cols="3" label="">
      <b-form-checkbox @input="changeProp" v-model="field.default_option"
        >Has Default</b-form-checkbox
      >
    </b-form-group>

    <b-form-group
      label-cols="3"
      v-if="field.default_option"
      label="Default Value"
    >
      <b-form-input
        :value="field.default_value"
        @change="changeProp"
        @input="setDefault"
        type="number"
      ></b-form-input>
    </b-form-group>
  </span>
</template>

<script>
import WidgetCommonProps from "../WidgetCommonProps.vue";
import WidgetPropMixin from "../WidgetPropMixin.js";

export default {
  name: "NumberProps",
  components: { WidgetCommonProps },
  mixins: [WidgetPropMixin],
  methods: {
    setDefault(value) {
      this.$set(this.field, "default_value", value);
    },
  },
};
</script>
